import { render, staticRenderFns } from "./RecycoSelect.vue?vue&type=template&id=0008795f&"
import script from "./RecycoSelect.vue?vue&type=script&lang=js&"
export * from "./RecycoSelect.vue?vue&type=script&lang=js&"
import style0 from "./RecycoSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports